import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useAuth } from '../context/AuthContext';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { refreshUserData } = useAuth();

  useEffect(() => {
    // Refresh user data to get updated credit balance
    refreshUserData();
    
    // Redirect to credits page after 5 seconds
    const timer = setTimeout(() => {
      navigate('/credits');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, refreshUserData]);

  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          textAlign: 'center', 
          mt: 4,
          background: 'linear-gradient(to bottom right, #4CAF50, #45a049)'
        }}
      >
        <CheckCircleOutlineIcon 
          sx={{ 
            fontSize: 64, 
            color: 'white', 
            mb: 2 
          }} 
        />
        <Typography variant="h4" gutterBottom sx={{ color: 'white' }}>
          Payment Successful!
        </Typography>
        <Typography variant="body1" sx={{ color: 'white', opacity: 0.9 }} paragraph>
          Your credits have been added to your account.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/credits')}
            sx={{ 
              mr: 2,
              bgcolor: 'white',
              color: '#4CAF50',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.9)'
              }
            }}
          >
            View Credits
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/quiz')}
            sx={{ 
              color: 'white',
              borderColor: 'white',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.9)',
                bgcolor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            Take Quiz
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default PaymentSuccess; 